import React from 'react'
import { publisherCtaClick, publisherCtaScroll  } from '../../ctas';
import GaImpressionTrigger from '../GaImpressionTrigger/Element';
import TrackedLink from '../TrackedLink/Element'
import './styles.scss';

export default ({publisher}) => {
  if (publisher.customButton === null) return null;

  const { customButton, name } = publisher;
  const { leadIn, text, url } =  customButton;

  const CtaLink = TrackedLink({
    ...publisherCtaClick,
    label: name
  });

  return (
      <GaImpressionTrigger {...publisherCtaScroll} label={name}>
        <div className="publisher-cta">
          <p>
            {leadIn}
          </p>
          <CtaLink className="cta-button" href={url}>{text}</CtaLink>
        </div>
      </GaImpressionTrigger>
  )
}
